export const tables = {
    Qualifications: [{
        name: 'QUALIFICATION',
        key: 'demographic_name',
        link: '',
        sort: false,
        type: 'text',
        content: '',
    },
    {
        name: 'EDIT',
        key: 'EDIT/DELETE',
        link: '',
        sort: false,
        type: 'edit/deleteIcon',
        content: 'Edit',
    },
    {
        name: 'REMOVE',
        key: 'REMOVE/DELETE',
        link: '',
        sort: false,
        type: 'remove/deleteicon',
        content: 'removeContent',
    }],
    Industries: [{
        name: 'INDUSTRY',
        key: 'demographic_name',
        link: '',
        sort: false,
    },
    {
        name: 'EDIT',
        key: 'EDIT/DELETE',
        link: '',
        sort: false,
        type: 'edit/deleteIcon',
        content: 'Edit',
    },
    {
        name: 'REMOVE',
        key: 'REMOVE/DELETE',
        link: '',
        sort: false,
        type: 'remove/deleteicon',
        content: 'removeContent',
    }]
}


// WEBPACK FOOTER //
// ./src/_pages/Admin/DemographicMasters/DemographicMastersTableData.js